// const API_URL = 'https://padmakshya.tamolo.in/csadmin/api/web-api/'
const API_URL = 'https://graphynix.com/2024/stjamessupply/csadmin/api/web-api/'
const DEFAULT_IMAGE ='/img/default_img.png'
const FRONT_URL =   ""  
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting,DEFAULT_IMAGE,FRONT_URL };